// extracted by mini-css-extract-plugin
export default {"container":"style_container__EJBLC","avasify":"style_avasify__mHlUh"};